module.exports = __webpack_public_path__ + "static/img/fx-mobile@2x.7ab5540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/featured/fx-mobile@2x.png
// module id = dDi1
// module chunks = 12